module.exports = __webpack_public_path__ + "img/courses-uiux.fe174a2b.svg";